"use client"

import { ErrorBanner } from "@/components/ui/error-banner"
import { useCustomSearchParams } from "@/hooks/use-search-params"

const SogeiErrorBanner = () => {
  const [searchParams] = useCustomSearchParams()
  if (!(searchParams.get("errorBanner") === "sogei")) return null
  return (
    <ErrorBanner
      title="SogeiErrorBanner.title"
      body="SogeiErrorBanner.body"
      bodyValues={{
        a: (chunks) => (
          <a
            href="https://www.adm.gov.it/portale/home"
            target="_blank"
            rel="noopener noreferrer"
          >
            {chunks}
          </a>
        ),
      }}
    />
  )
}

export { SogeiErrorBanner }
